import { useParams } from 'react-router-dom'
import RouteContainer from '../../../common/styles/RouteContainer'
import useBookDetail from './useBookDetail'
import NoContentForFullScreen from '../../../common/NoContentForFullScreen'
import RowSpacer from '../../../common/styles/RowSpacer'
import BookDetailInfoCard from './BookDetailInfoCard'
import BookDetailMemoCard from './memo/BookDetailMemoCard'
import BookDetailReadingSessionCard from './reading/BookDetailReadingSessionCard'
import RouteTitle from '../../../common/RouteTitle/RouteTitle'
import booksitoutIcon from '../../../config/BooksitoutIcon'
import RouteTitleConfig from '../../../config/RouteTitleConfig'
import { useEffect } from 'react'
import useBookDetailStore from './useBookDetailStore'
import useLoginStore from '../../login/useLoginStore'
import useHtmlTitle from '../../../common/useHtmlTitle'
import BookDetailReviewCard from './review/BookDetailReviewCard'

const BookDetailRoute = () => {
	const { bookId } = useParams()
	const [bookDetailFromServer, isLoading, isError] = useBookDetail(Number(bookId))
	useHtmlTitle(bookDetailFromServer?.book.title)

	const isLoggedIn = useLoginStore(state => state.isLoggedIn())
	useEffect(() => {
		let userId = bookDetailFromServer?.book?.userId
		if (!isLoggedIn && userId != undefined) {
			window.location.href = `/users/${userId}/books/${bookId}`
		}
	}, [isLoggedIn, bookDetailFromServer])

	const { init, book } = useBookDetailStore()
	useEffect(() => {
		if (bookDetailFromServer != null) {
			init(bookDetailFromServer)
		}
	}, [bookDetailFromServer])

	if (isLoading) {
		return <></>
	}

	if (isError || bookDetailFromServer == null) {
		return <NoContentForFullScreen message={'찾으시는 책이 없어요.'} />
	}

	return (
		<RouteContainer>
			<RouteTitle icon={<booksitoutIcon.book />} title={'내 서재'} subTitle={'내가 등록한 책을 확인하고 관리할 수 있어요'} currentKey={'mine'} buttons={RouteTitleConfig.Book} rightUi={undefined} />

			{book?.status === 'DONE' && (
				<>
					<RowSpacer/>
					<BookDetailReviewCard />
				</>
			)}

			<RowSpacer/>
			<BookDetailInfoCard />

			<RowSpacer size={10} />
			<BookDetailMemoCard />

			<RowSpacer size={10} />
			<BookDetailReadingSessionCard />
		</RouteContainer>
	)
}

export default BookDetailRoute
